import {Config} from '../Config'
import {RecommendationParams} from './IO/Input/RecommendationParams'
import {RecommendationInterface} from './Recommendation'
import {AxiosRecommendationRequest} from './Infrastructure/AxiosRequest'
import {Product} from './IO/Output/Product'
import {AxiosError, AxiosResponse} from 'axios'

import {RecommendationError} from './IO/Output/Error'
import {ErrorResponse} from './IO/Input/Error/ErrorResponse'
import {UnknownError} from '../utils/UnknownError'
import {RecommendationResponse} from './IO/Output/RecommendationResponse'
import {FilterApi} from './FilterApi'

type AllFiltersToUrlQuery = Record<string, string>;

/**
 * <h4>Recommendation implementation</h4>
 *
 * Documentation of Recommendation module is in interface description {@link RecommendationInterface}
 */
export class RecommendationImpl implements RecommendationInterface {
    private config: Config;
    private apiRequest: AxiosRecommendationRequest;

    /**
     * @param config Customer configuration
     */
    constructor(config: Config) {
        this.config = config
        this.apiRequest = new AxiosRecommendationRequest(config)
    }

    async getRecommendation(params: RecommendationParams): Promise<Product[]> {
        const url = this.getRecommendationUrl(params)
        return this.apiRequest.getRecommendations(url)
            .then((response: AxiosResponse<RecommendationResponse>) => {
                return response.data.products.map<Product>((productResponse): Product => {
                    return Product.createFromResponse(productResponse)
                })
            })
            .catch((reason: AxiosError<ErrorResponse>) => {
                throw new RecommendationError(reason.response?.data.data?.error_message ?? UnknownError.messageByAxiosError(reason))
            })
    }

    private static getPlacementId(placementId :string){
        return placementId.replace('_qS_', '')
    }

    private getRecommendationUrl(params: RecommendationParams): string {
        const host = this.config.getHost()
        const placementId = RecommendationImpl.getPlacementId(params.placementId)
        const requestParams = new URLSearchParams([
            ['customer', this.config.getCustomer()],
            ['qparams', RecommendationImpl.getQParamsBase64(params)]
        ])

        return `https://qsdw1.${host}/QjC/${placementId}/?${requestParams}`
    }

    private static getQParamsBase64(params: RecommendationParams) {
        return Buffer.from(JSON.stringify(RecommendationImpl.getAllFilters(params))).toString('base64')
    }

    private static getAllFilters(recommendationParams: RecommendationParams): AllFiltersToUrlQuery {
        if (!recommendationParams?.filters) {
            return {}
        }
        return FilterApi.getFilterParams(recommendationParams.filters)
    }
}
